import { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { getProgramDuration } from '../utils/programDurationCalculator';

/**
 * Hook: Check if member needs final auto-evaluation (2 weeks before program end)
 * Returns: { modalOpen, onClose, profile, auth }
 */
export const useFinalEvaluationReminder = (auth, profile) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [checkInProgress, setCheckInProgress] = useState(false);

  useEffect(() => {
    if (!auth?.uid || !profile?.uid || checkInProgress) return;

    const checkAndOpen = async () => {
      setCheckInProgress(true);
      try {
        // Skip if already opened reminder in this session
        if (sessionStorage.getItem(`final_eval_reminder_${auth.uid}`)) {
          return;
        }

        // Skip if already completed final eval
        if (profile.autoEvaluation_final) {
          return;
        }

        const firestore = firebase.firestore();
        const duration = await getProgramDuration(auth.uid, firestore);

        const today = new Date();
        const twoWeeksBeforeEnd = new Date(duration.endDate);
        twoWeeksBeforeEnd.setDate(twoWeeksBeforeEnd.getDate() - 14);

        // Open modal if within 2 weeks before end
        if (today >= twoWeeksBeforeEnd && today <= duration.endDate) {
          setModalOpen(true);
          sessionStorage.setItem(`final_eval_reminder_${auth.uid}`, 'true');
        }
      } catch (error) {
        console.error('Error checking final evaluation reminder:', error);
      } finally {
        setCheckInProgress(false);
      }
    };

    checkAndOpen();
  }, [auth?.uid, profile?.uid, checkInProgress]);

  return {
    modalOpen,
    setModalOpen,
    profile,
    auth
  };
};
